import React, { createContext, ReactNode, useContext } from "react";
import { Subvertical } from "src/server/constants.js";
import { ExternalProps } from "src/types.js";

const context = createContext<ExternalProps>({
	subvertical: Subvertical.Car,
	proxyUrl: "",
	variant: "pagination",
	locale: "nb",
	favoriteBaseUrl: "",
});

export const ExternalPropsProvider = (props: ExternalProps & { children?: ReactNode }) => {
	const { children, ...externalProps } = props;
	return <context.Provider value={externalProps}>{children}</context.Provider>;
};

export const useExternalProps = () => {
	return useContext(context);
};
